export type ISetMomentLang = IDCA.IGenericFunc;

export function setMomentLang() {
  if (typeof window.moment !== 'undefined') {
    window.moment.locale(window.language);
  }
}
